module.exports = __webpack_public_path__ + "static/img/10015 (1).91331bd.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10015 (1).webp
// module id = joaO
// module chunks = 14